module.exports = __webpack_public_path__ + "static/media/mypageicon.04c2c7b0.svg";